var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23475 9H6.1999C6.33653 6.48347 6.98526 4.15607 8.01759 2.29368C4.95716 3.1478 2.63677 5.77602 2.23475 9ZM10.1634 2.61029C9.10098 4.21065 8.35836 6.44463 8.20306 9H12.1409C11.9809 6.44133 11.232 4.20668 10.1634 2.61029ZM12.1443 11H8.20306C8.35928 13.5705 9.10979 15.8158 10.1823 17.418C11.2486 15.8118 11.9928 13.5672 12.1443 11ZM8.01759 17.7063C6.98526 15.8439 6.33653 13.5165 6.1999 11H2.23475C2.63677 14.224 4.95716 16.8522 8.01759 17.7063ZM12.3466 17.7011C13.372 15.8374 14.0148 13.5123 14.1473 11H18.111C17.7097 14.2175 15.3979 16.8416 12.3466 17.7011ZM18.111 9H14.1442C14.0035 6.47922 13.3487 4.14947 12.3095 2.2885C15.3791 3.13713 17.7081 5.76948 18.111 9ZM0.172852 10C0.172852 4.47715 4.65 0 10.1729 0C15.6957 0 20.1729 4.47715 20.1729 10C20.1729 15.5228 15.6957 20 10.1729 20C4.65 20 0.172852 15.5228 0.172852 10Z",
    fill: "#392A93"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.ebdb4f114822e3107c6333d6f888b021.svg";
export { ForwardRef as ReactComponent };